.wrap {
  padding: 64px 28px 0;
  text-align: center;
}
.divider {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
}
.line {
  width: 46px;
  height: 1px;
  background: var(--rule);
}
.dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: radial-gradient(circle at 32% 28%, #ffffff 0%, #f5ede2 38%, #e0d4c1 70%, #cdbda4 100%);
  box-shadow: 0 2px 5px rgba(120, 100, 70, 0.3);
}
.eyebrow {
  font-family: var(--font-script);
  font-size: 24px;
  color: var(--pink);
  margin-top: 32px;
}
.title {
  margin: 2px 0 0;
  font-family: var(--font-body);
  font-weight: 400;
  font-size: 27px;
  letter-spacing: 3px;
  text-indent: 2px;
  color: var(--ink-2);
}
.grid {
  display: grid;
  align-items: stretch;
  margin-top: 28px;
}
.card {
  text-align: center;
  padding: 2px 6px;
}
.mid {
  background: #e2e7ed;
}
.cardEyebrow {
  font-family: var(--font-script);
  font-size: 20px;
  color: var(--role-ink);
}
.cardName {
  width: fit-content;
  font-family: var(--font-body);
  font-weight: 400;
  font-size: 19px;
  letter-spacing: 1px;
  color: var(--ink-2);
  background: var(--role-soft);
  border-radius: 999px;
  margin: 4px auto 0;
  padding: 1px 9px 3px;
}
.actions {
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-top: 16px;
}
.tel {
  composes: tapTarget from '../styles/tapTarget.module.css';
  font-family: var(--font-detail);
  font-weight: 400;
  font-size: 12.5px;
  line-height: var(--font-detail-line-height);
  letter-spacing: 2px;
  color: var(--ink-4);
  border-bottom: 1px solid var(--rule);
  padding-bottom: 3px;
}
.sms {
  composes: tapTarget from '../styles/tapTarget.module.css';
  font-family: var(--font-detail);
  font-weight: 400;
  font-size: 12.5px;
  line-height: var(--font-detail-line-height);
  letter-spacing: 2px;
  color: var(--ink-4);
  border-bottom: 1px solid var(--rule);
  padding-bottom: 3px;
}
